var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinsBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 206,
    viewBox: "0 0 219 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_476_15227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.745 201.734C149.61 201.734 180.305 197.326 180.305 191.888C180.305 186.451 149.61 182.043 111.745 182.043C73.88 182.043 43.1846 186.451 43.1846 191.888C43.1846 197.326 73.88 201.734 111.745 201.734Z",
    fill: "#363A4E",
    fillOpacity: 0.64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_15227)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.3261,
    cy: 39.5737,
    rx: 10.8036,
    ry: 10.9965,
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2793 39.3809C85.2793 45.5606 80.2696 50.5703 74.0898 50.5703C67.9101 50.5703 62.9004 45.5606 62.9004 39.3809C62.9004 33.2011 67.9101 28.1914 74.0898 28.1914C80.2696 28.1914 85.2793 33.2011 85.2793 39.3809ZM66.0925 39.3809C66.0925 43.7977 69.673 47.3782 74.0898 47.3782C78.5066 47.3782 82.0872 43.7977 82.0872 39.3809C82.0872 34.9641 78.5066 31.3835 74.0898 31.3835C69.673 31.3835 66.0925 34.9641 66.0925 39.3809Z",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1147 38.6006C70.4559 38.2144 71.3428 37.6738 72.1616 38.6006",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7056 42.4202C75.1939 42.9994 73.8634 43.8103 72.6353 42.4202",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2544 38.6006C76.5955 38.2144 77.4825 37.6738 78.3012 38.6006",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0894 38.4382C70.4305 38.0521 71.3175 37.5115 72.1362 38.4382",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7056 42.27C75.1939 42.8493 73.8634 43.6602 72.6353 42.27",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.23 38.4382C76.5711 38.0521 77.4581 37.5115 78.2768 38.4382",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.3261,
    cy: 24.5737,
    rx: 10.8036,
    ry: 10.9965,
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.279 24.3809C108.279 30.5606 103.27 35.5703 97.0898 35.5703C90.9101 35.5703 85.9004 30.5606 85.9004 24.3809C85.9004 18.2011 90.9101 13.1914 97.0898 13.1914C103.27 13.1914 108.279 18.2011 108.279 24.3809ZM89.0925 24.3809C89.0925 28.7977 92.673 32.3782 97.0898 32.3782C101.507 32.3782 105.087 28.7977 105.087 24.3809C105.087 19.9641 101.507 16.3835 97.0898 16.3835C92.673 16.3835 89.0925 19.9641 89.0925 24.3809Z",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1147 23.6006C93.4559 23.2144 94.3428 22.6738 95.1616 23.6006",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7056 27.4202C98.1939 27.9994 96.8634 28.8103 95.6353 27.4202",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2544 23.6006C99.5955 23.2144 100.482 22.6738 101.301 23.6006",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0894 23.4382C93.4305 23.0521 94.3175 22.5115 95.1362 23.4382",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7056 27.27C98.1939 27.8493 96.8634 28.6602 95.6353 27.27",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.23 23.4382C99.5711 23.0521 100.458 22.5115 101.277 23.4382",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.326,
    cy: 47.5737,
    rx: 10.8036,
    ry: 10.9965,
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.279 47.3809C127.279 53.5606 122.27 58.5703 116.09 58.5703C109.91 58.5703 104.9 53.5606 104.9 47.3809C104.9 41.2011 109.91 36.1914 116.09 36.1914C122.27 36.1914 127.279 41.2011 127.279 47.3809ZM108.093 47.3809C108.093 51.7977 111.673 55.3782 116.09 55.3782C120.507 55.3782 124.087 51.7977 124.087 47.3809C124.087 42.9641 120.507 39.3835 116.09 39.3835C111.673 39.3835 108.093 42.9641 108.093 47.3809Z",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.115 46.6006C112.456 46.2144 113.343 45.6738 114.162 46.6006",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.706 50.4202C117.194 50.9994 115.863 51.8103 114.635 50.4202",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.254 46.6006C118.596 46.2144 119.482 45.6738 120.301 46.6006",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.089 46.4382C112.43 46.0521 113.317 45.5115 114.136 46.4382",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.706 50.27C117.194 50.8493 115.863 51.6602 114.635 50.27",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.23 46.4382C118.571 46.0521 119.458 45.5115 120.277 46.4382",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.69,
    y: 25.6523,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(127.1 120.69 25.6523)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.7,
    y: 43,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(127.1 107.7 43)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.65,
    cy: 33.1858,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(126.719 110.65 33.1858)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.684,
    cy: 35.464,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(126.692 113.684 35.464)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.657,
    cy: 35.5103,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(126.719 113.657 35.5103)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.472 39.7047L103.919 40.528L102.569 39.6072L102.768 38.5427L104.472 39.7047Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.727 36.0167L105.166 36.8342L103.712 35.8202L104.134 34.8863L105.727 36.0167Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.497 32.7263L106.931 33.5397L105.46 32.4979L106.011 31.6349L107.497 32.7263Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.933 29.6685L109.354 30.4726L107.764 29.3087L108.412 28.5155L109.933 29.6685Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.474 26.9611L111.866 27.7439L110.333 26.5337L111.077 25.8577L112.474 26.9611Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.535 24.7368L114.889 25.4888L113.39 24.1808L114.333 23.6698L115.535 24.7368Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.763 31.9037C116.807 32.3052 116.632 33.2329 115.578 33.7318",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.807 32.0228C116.851 32.4243 116.676 33.352 115.622 33.8509",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.347 37.3143C113.392 37.7158 113.217 38.6435 112.162 39.1424",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.417 37.4877C113.461 37.8891 113.286 38.8168 112.232 39.3158",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.194 33.6073C112.804 33.727 112.006 34.3002 111.931 35.6355",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.523 33.7382C113.133 33.8436 112.333 34.3454 112.254 35.5093",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.3203,
    y: 28.1455,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(65.4335 83.3203 28.1455)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.4248,
    y: 47.8127,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(65.4335 92.4248 47.8127)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.1863,
    cy: 40.5588,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(65.0519 85.1863 40.5588)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.6315,
    cy: 38.9693,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(65.0249 88.6315 38.9693)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.6597,
    cy: 39.015,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(65.0519 88.6597 39.015)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9923 49.0906L88.4549 49.9675L87.0037 50.7186L86.1611 50.0383L87.9923 49.0906Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3414 46.2355L85.7949 47.1171L84.2123 47.9156L83.5905 47.101L85.3414 46.2355Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2856 43.115L83.7326 44L82.1177 44.8001L81.6194 43.9057L83.2856 43.115Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7503 39.5199L82.183 40.4119L80.4043 41.2582L80.0134 40.3119L81.7503 39.5199Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5733 35.9984L80.9736 36.9055L79.1808 37.6804L78.9388 36.7049L80.5733 35.9984Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0679 32.249L80.4232 33.1746L78.5607 33.8727L78.5584 32.8004L80.0679 32.249Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.959 34.569C87.3334 34.7204 88.067 35.3146 88.0057 36.4797",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.085 34.587C87.4594 34.7385 88.193 35.3327 88.1317 36.4977",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1006 40.1432C90.475 40.2947 91.2086 40.8889 91.1473 42.0539",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2861 40.1649C90.6606 40.3164 91.3942 40.9106 91.3328 42.0756",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7644 38.5195C86.6849 38.9192 86.8106 39.8937 87.9502 40.5937",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0359 38.2922C86.9436 38.6854 87.0058 39.6274 87.9928 40.2494",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 182.38C167.047 184.996 167.903 188.042 166.658 190.579C165.468 193.011 162.6 194.344 159.886 194.205C157.586 194.02 155.4 193.126 153.632 191.649C153.317 191.401 152.948 191.231 152.554 191.151C152.161 191.072 151.754 191.087 151.367 191.193C132.047 196.642 112.673 196.667 97.9039 195.29C89.5818 194.547 81.3298 193.165 73.2214 191.158C72.8388 191.064 72.4394 191.06 72.0548 191.146C71.6702 191.232 71.311 191.406 71.0056 191.654C69.2338 193.139 67.0408 194.038 64.7317 194.225C62.018 194.364 59.1449 193.031 57.9549 190.599C56.7648 188.166 57.5117 185.219 58.7615 182.672C58.9913 182.192 59.0621 181.652 58.9637 181.13C58.8652 180.607 58.6027 180.129 58.2138 179.764C51.666 173.572 47.802 164.799 46.4277 155.887C45.168 147.733 46.9605 139.425 49.2859 131.509C54.4444 113.922 67.54 98.3175 80.3419 84.075C80.6461 83.7351 80.8465 83.316 80.9198 82.8667C80.993 82.4175 80.9358 81.9568 80.7551 81.5386L67.8737 51.6617C67.6909 51.2364 67.636 50.7676 67.7155 50.312C67.795 49.8563 68.0056 49.4333 68.3217 49.0942C68.6377 48.7551 69.0458 48.5144 69.4965 48.4013C69.9472 48.2881 70.4213 48.3073 70.8612 48.4565C72.4696 49.0163 74.043 49.7495 75.5816 50.4034C77.3132 51.1827 79.0869 51.8657 80.8946 52.4494C81.7653 52.7197 82.6537 52.9299 83.5535 53.0785C84.3659 53.2189 85.1888 53.2901 86.0133 53.2915C90.1959 53.2915 94.1246 51.3645 97.6599 49.1352C101.195 46.906 104.541 44.3299 108.41 42.7546C112.279 41.1793 116.905 40.773 120.51 42.8636C121.142 43.2352 121.736 43.6683 122.283 44.1565C125.768 47.2329 127.73 52.1918 131.948 54.2526C133.041 54.7776 134.223 55.0983 135.433 55.1988C139.212 55.5703 143.32 54.2575 147.274 54.1733C147.68 54.1663 148.081 54.2617 148.44 54.4505C148.799 54.6394 149.104 54.9156 149.327 55.2534C149.549 55.5911 149.682 55.9795 149.714 56.3823C149.745 56.7851 149.673 57.1891 149.505 57.5568L138.55 81.4247C138.349 81.8695 138.288 82.3649 138.377 82.8446C138.466 83.3244 138.7 83.7657 139.048 84.1097C147.597 92.5611 157.571 103.123 163.83 113.759C170.383 124.89 174.984 137.463 174.959 150.363C174.959 160.301 171.931 171.799 165.951 179.794C165.676 180.162 165.509 180.598 165.469 181.055C165.429 181.511 165.516 181.97 165.722 182.38Z",
    fill: "#B4BDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9039 195.29C89.5818 194.547 81.3298 193.166 73.2214 191.159C72.8388 191.064 72.4394 191.06 72.0548 191.146C71.6702 191.232 71.311 191.406 71.0056 191.654C69.2338 193.139 67.0408 194.038 64.7317 194.225C62.018 194.364 59.1449 193.031 57.9549 190.599C56.7648 188.166 57.5117 185.219 58.7615 182.673C58.9913 182.193 59.0621 181.652 58.9637 181.13C58.8652 180.607 58.6027 180.129 58.2138 179.765C51.666 173.572 47.802 164.799 46.4277 155.887C45.168 147.733 46.9605 139.425 49.2859 131.509C54.4444 113.922 67.54 98.3176 80.3419 84.0751C80.6461 83.7353 80.8465 83.3161 80.9198 82.8668C80.993 82.4176 80.9359 81.9569 80.7551 81.5388L67.8737 51.6618C67.6909 51.2366 67.636 50.7677 67.7155 50.3121C67.795 49.8564 68.0056 49.4335 68.3217 49.0944C68.6377 48.7553 69.0458 48.5145 69.4965 48.4014C69.9472 48.2882 70.4213 48.3074 70.8612 48.4566C72.4696 49.0164 74.043 49.7496 75.5816 50.4035H75.6364C77.2835 51.1096 78.7409 52.1907 79.8911 53.5597C81.0414 54.9287 81.8524 56.5473 82.2589 58.2852C84.4066 67.4796 86.5511 76.6707 88.6922 85.8586C74.5459 96.4054 66.0711 114.155 63.5018 131.558C60.9325 148.961 66.0462 167.474 77.6978 180.701C83.2734 186.983 90.1725 191.964 97.9039 195.29Z",
    fill: "#7E8ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.668 85.001C118.419 91.014 119.644 96.9972 122.239 102.434C122.916 103.846 123.961 105.406 125.53 105.456C126.82 105.5 127.945 104.43 128.343 103.207C128.742 101.983 128.572 100.66 128.343 99.397C127.385 94.5256 125.355 89.9256 122.398 85.9274",
    fill: "#7E8ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.789 86.5016C127.924 90.127 129.931 93.4224 132.635 96.1023C133.337 96.7958 134.288 97.4993 135.234 97.1971C135.61 97.0398 135.927 96.7693 136.14 96.4237C136.354 96.0781 136.453 95.6747 136.424 95.27C136.346 94.4594 136.061 93.682 135.597 93.0111C133.989 90.3193 131.801 88.0165 129.189 86.2688",
    fill: "#7E8ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5907 86.1255C92.5154 93.2572 89.2118 101.484 87.9507 110.132C87.6072 112.52 87.6221 115.398 89.5939 116.795C91.3367 118.029 93.906 117.404 95.4446 115.928C96.9832 114.452 97.7251 112.342 98.3077 110.296C100.495 102.659 101.299 94.6962 100.683 86.7794",
    fill: "#7E8ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1827 80.6571C95.5536 74.435 93.8756 67.5243 95.3495 60.9307C95.4658 60.2481 95.7163 59.5949 96.0864 59.0086C96.2739 58.7159 96.53 58.4728 96.8326 58.3003C97.1353 58.1277 97.4756 58.0308 97.8242 58.0178C98.2124 58.0567 98.5833 58.1973 98.8991 58.4253C99.2149 58.6533 99.4643 58.9606 99.6217 59.3157C99.9389 60.0806 100.155 60.8833 100.264 61.7035C101.509 68.639 101.509 72.7259 99.8309 82.2127",
    fill: "#7E8ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.353 58.582C128.442 67.081 125.028 76.353 123.259 85.9969L112.24 81.6821C112.347 70.0788 115.048 58.6447 120.147 48.2086C120.383 47.7351 120.737 47.3295 121.174 47.0301C121.612 46.7307 122.119 46.5475 122.648 46.4978C123.176 46.4482 123.709 46.5338 124.195 46.7465C124.681 46.9592 125.105 47.292 125.425 47.7132C127.343 50.2347 129.145 52.8751 131.943 54.2424H131.978C132.365 54.4263 132.71 54.6874 132.992 55.0096C133.273 55.3317 133.485 55.708 133.613 56.115C133.742 56.5221 133.786 56.9511 133.741 57.3755C133.696 57.7999 133.564 58.2106 133.353 58.582Z",
    fill: "#7E8ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3503 90.4151C77.2857 90.4073 76.2644 89.9949 75.4954 89.2623C74.7264 88.5298 74.268 87.5326 74.2139 86.4747C74.1598 85.4169 74.5142 84.3785 75.2045 83.5721C75.8948 82.7658 76.8688 82.2524 77.9271 82.1371L140.417 75.6971C141.514 75.5922 142.607 75.9226 143.459 76.6164C144.312 77.3102 144.854 78.3111 144.967 79.4008C145.081 80.4906 144.757 81.5809 144.066 82.434C143.375 83.2871 142.373 83.8339 141.279 83.9552L78.7835 90.3953C78.6396 90.4093 78.495 90.4159 78.3503 90.4151Z",
    fill: "#CBD1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.355 90.4163C77.27 90.4027 76.2331 89.9692 75.464 89.2077C74.6949 88.4462 74.2543 87.4165 74.2355 86.3372C74.2167 85.2578 74.6213 84.2136 75.3634 83.4261C76.1055 82.6385 77.1268 82.1695 78.2106 82.1186L139.227 80.0181C140.336 79.98 141.414 80.3816 142.225 81.1346C143.036 81.8876 143.513 82.9303 143.552 84.0332C143.59 85.1362 143.186 86.2092 142.429 87.016C141.673 87.8229 140.625 88.2976 139.516 88.3357L78.4994 90.4362L78.355 90.4163Z",
    fill: "#CBD1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.312 88.2267C79.2271 88.2131 78.1901 87.7795 77.421 87.018C76.652 86.2565 76.2113 85.2268 76.1925 84.1475C76.1737 83.0681 76.5783 82.0239 77.3204 81.2364C78.0625 80.4488 79.0838 79.9798 80.1676 79.9289L139.422 77.8582C140.504 77.8567 141.544 78.2736 142.323 79.0208C143.102 79.7681 143.559 80.7873 143.597 81.8633C143.635 82.9393 143.252 83.988 142.528 84.7879C141.803 85.5879 140.795 86.0766 139.715 86.151L80.4614 88.2267H80.312Z",
    fill: "#939ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.367 88.3347H139.188L80.8355 85.8577C79.7488 85.7855 78.7336 85.2935 78.0066 84.4866C77.2796 83.6798 76.8985 82.6222 76.9447 81.5397C76.9908 80.4571 77.4606 79.4354 78.2536 78.6927C79.0466 77.9501 80.1001 77.5453 81.189 77.5649L139.547 80.0072C140.657 80.0308 141.712 80.4922 142.48 81.2898C143.248 82.0873 143.666 83.1558 143.642 84.2601C143.618 85.3644 143.155 86.4141 142.353 87.1782C141.551 87.9423 140.477 88.3583 139.367 88.3347Z",
    fill: "#CBD1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.792 89.4698C128.18 89.4698 130.927 86.7373 130.927 83.3666C130.927 79.9959 128.18 77.2634 124.792 77.2634C121.404 77.2634 118.658 79.9959 118.658 83.3666C118.658 86.7373 121.404 89.4698 124.792 89.4698Z",
    fill: "#939ED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.847 82.5739C129.845 84.0755 129.287 85.5238 128.28 86.6418C127.273 87.7599 125.886 88.4692 124.386 88.6342C122.886 88.7991 121.377 88.4081 120.149 87.5359C118.92 86.6637 118.058 85.3715 117.727 83.9065C117.676 83.6843 117.638 83.4594 117.613 83.2328C117.613 83.0148 117.578 82.7969 117.578 82.5739C117.576 81.54 117.838 80.5225 118.34 79.617C118.841 78.7115 119.566 77.9477 120.446 77.3971C120.638 77.2782 120.838 77.1707 121.043 77.0751C121.871 76.6741 122.781 76.4673 123.702 76.4707C124.509 76.4688 125.308 76.6252 126.054 76.9311C126.799 77.237 127.477 77.6864 128.048 78.2534C128.619 78.8204 129.071 79.4939 129.38 80.2353C129.689 80.9767 129.847 81.7714 129.847 82.5739Z",
    fill: "#CBD1F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.0361,
    y: 171.841,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(-1.20042 90.0361 171.841)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.701,
    y: 171.283,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(-1.20042 111.701 171.283)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.171,
    cy: 175.052,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(-1.58202 102.171 175.052)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.079,
    cy: 171.259,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(-1.60906 102.079 171.259)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.132,
    cy: 171.251,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(-1.58202 102.132 171.251)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.116 175.86L112.105 175.783L112.218 177.413L111.26 177.917L111.116 175.86Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.444 177.161L108.433 177.094L108.538 178.864L107.544 179.112L107.444 177.161Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.764 177.81L104.753 177.751L104.847 179.55L103.829 179.653L103.764 177.81Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8545 177.793L100.845 177.75L100.916 179.719L99.8926 179.702L99.8545 177.793Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1556 177.478L97.147 177.47L97.1474 179.423L96.1559 179.258L96.1556 177.478Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5134 176.453L93.504 176.494L93.4061 178.481L92.4209 178.058L92.5134 176.453Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.42 170.475C104.728 170.213 105.595 169.84 106.598 170.435",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.42 170.341C104.728 170.08 105.595 169.706 106.598 170.301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.672 171.755C99.98 172.017 100.847 172.39 101.85 171.795",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.672 171.548C99.98 171.81 100.847 172.183 101.85 171.588",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0361,
    y: 167.841,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(-1.20042 95.0361 167.841)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.701,
    y: 167.283,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(-1.20042 116.701 167.283)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.171,
    cy: 171.052,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(-1.58202 107.171 171.052)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.079,
    cy: 167.259,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(-1.60906 107.079 167.259)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.132,
    cy: 167.251,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(-1.58202 107.132 167.251)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.116 171.86L117.105 171.783L117.218 173.413L116.26 173.917L116.116 171.86Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.444 173.161L113.433 173.094L113.538 174.864L112.544 175.112L112.444 173.161Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.764 173.81L109.753 173.751L109.847 175.55L108.829 175.653L108.764 173.81Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.854 173.793L105.845 173.75L105.916 175.719L104.893 175.702L104.854 173.793Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.156 173.478L102.147 173.47L102.147 175.423L101.156 175.258L101.156 173.478Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5134 172.453L98.504 172.494L98.4061 174.481L97.4209 174.058L97.5134 172.453Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.42 166.475C109.728 166.213 110.595 165.84 111.598 166.435",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.42 166.341C109.728 166.08 110.595 165.706 111.598 166.301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.672 167.755C104.98 168.017 105.847 168.39 106.85 167.795",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.672 167.548C104.98 167.81 105.847 168.183 106.85 167.588",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.0361,
    y: 163.841,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(-1.20042 89.0361 163.841)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.701,
    y: 163.283,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(-1.20042 110.701 163.283)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.171,
    cy: 167.052,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(-1.58202 101.171 167.052)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.079,
    cy: 163.259,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(-1.60906 101.079 163.259)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.132,
    cy: 163.251,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(-1.58202 101.132 163.251)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.116 167.86L111.105 167.783L111.218 169.413L110.26 169.917L110.116 167.86Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.444 169.161L107.433 169.094L107.538 170.864L106.544 171.112L106.444 169.161Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.764 169.81L103.753 169.751L103.847 171.55L102.829 171.653L102.764 169.81Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8545 169.793L99.8449 169.75L99.9164 171.719L98.8926 171.702L98.8545 169.793Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1556 169.478L96.147 169.47L96.1474 171.423L95.1559 171.258L95.1556 169.478Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5134 168.453L92.504 168.494L92.4061 170.481L91.4209 170.058L91.5134 168.453Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42 162.475C103.728 162.213 104.595 161.84 105.598 162.435",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42 162.341C103.728 162.08 104.595 161.706 105.598 162.301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.672 163.755C98.98 164.017 99.8469 164.39 100.85 163.795",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.672 163.548C98.98 163.81 99.8469 164.183 100.85 163.588",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.958,
    y: 155.956,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(-1.20042 90.958 155.956)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.623,
    y: 155.399,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(-1.20042 112.623 155.399)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.093,
    cy: 159.167,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(-1.58202 103.093 159.167)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 155.374,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(-1.60906 103 155.374)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.054,
    cy: 155.366,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(-1.58202 103.054 155.366)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.038 159.975L113.026 159.898L113.14 161.528L112.182 162.032L112.038 159.975Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.366 161.276L109.355 161.21L109.46 162.979L108.466 163.227L108.366 161.276Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.686 161.925L105.675 161.866L105.769 163.666L104.751 163.768L104.686 161.925Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.776 161.909L101.767 161.865L101.838 163.834L100.815 163.817L100.776 161.909Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0774 161.593L98.0689 161.585L98.0692 163.538L97.0778 163.374L97.0774 161.593Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4353 160.569L94.4259 160.61L94.328 162.596L93.3427 162.173L93.4353 160.569Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.342 154.59C105.65 154.329 106.517 153.955 107.52 154.55",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.342 154.456C105.65 154.195 106.517 153.821 107.52 154.416",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.594 155.871C100.902 156.132 101.769 156.506 102.772 155.91",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.594 155.663C100.902 155.925 101.769 156.299 102.772 155.703",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6846,
    y: 154.551,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(-32.7217 84.6846 154.551)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.861,
    y: 142.748,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(-32.7217 102.861 142.748)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.7075,
    cy: 150.943,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(-33.1033 96.7075 150.943)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.6455,
    cy: 147.758,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(-33.1303 94.6455 147.758)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.6868,
    cy: 147.724,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(-33.1033 94.6868 147.724)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.755 146.955L105.558 146.373L106.507 147.703L105.953 148.633L104.755 146.955Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.305 149.984L103.113 149.41L104.128 150.863L103.41 151.594L102.305 149.984Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5075 152.462L100.32 151.893L101.341 153.379L100.527 153.999L99.5075 152.462Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1666 154.491L96.9882 153.937L98.0783 155.577L97.1969 156.098L96.1666 154.491Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8479 156.156L93.689 155.631L94.7104 157.296L93.7791 157.674L92.8479 156.156Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2079 157.188L90.0737 156.705L91.0289 158.45L89.9678 158.604L89.2079 157.188Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5269 150.037C90.6237 149.645 91.1078 148.835 92.2697 148.73",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5269 149.91C90.6237 149.518 91.1078 148.708 92.2697 148.603",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5991 146.137C95.6959 145.745 96.1801 144.934 97.342 144.83",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5942 145.95C95.6911 145.558 96.1752 144.748 97.3371 144.643",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4651 149.67C94.8721 149.692 95.8189 149.429 96.3502 148.202",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2015 149.433C94.6038 149.469 95.5275 149.274 96.0032 148.208",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.9224,
    y: 179.21,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(-58.1764 74.9224 179.21)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2622,
    y: 160.741,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(-58.1764 86.2622 160.741)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2274,
    cy: 170.785,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(-58.558 84.2274 170.785)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.9969,
    cy: 168.795,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(-58.585 80.9969 168.795)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.0194,
    cy: 168.747,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(-58.558 81.0194 168.747)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7796 163.725L90.2539 162.855L91.6827 163.647L91.5826 164.726L89.7796 163.725Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8692 167.513L89.3524 166.647L90.8935 167.523L90.5592 168.492L88.8692 167.513Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4087 170.952L87.8983 170.09L89.4585 170.992L88.9895 171.902L87.4087 170.952Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2643 174.221L85.7677 173.367L87.4571 174.38L86.8853 175.23L85.2643 174.221Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9828 177.151L83.5167 176.315L85.1545 177.379L84.476 178.121L82.9828 177.151Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1401 179.647L80.7144 178.839L82.3267 180.004L81.4349 180.599L80.1401 179.647Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2576 172.624C78.1765 172.228 78.2653 171.288 79.2695 170.694",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2029 172.509C78.1218 172.113 78.2106 171.174 79.2148 170.58",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1609 166.922C81.0798 166.526 81.1686 165.586 82.1728 164.993",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0765 166.756C80.9953 166.36 81.0842 165.42 82.0883 164.826",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6554 170.599C82.0324 170.444 82.7744 169.8 82.7265 168.463",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3161 170.499C81.6947 170.358 82.4448 169.785 82.4164 168.619",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.3477,
    y: 130.129,
    width: 0.871442,
    height: 3.48577,
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.0405,
    y: 131.436,
    width: 3.48577,
    height: 0.871442,
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3125,
    y: 137.535,
    width: 0.871442,
    height: 3.48577,
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.0054,
    y: 138.843,
    width: 3.48577,
    height: 0.871442,
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.3477,
    y: 152.569,
    width: 0.871442,
    height: 3.48577,
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.0405,
    y: 153.876,
    width: 3.48577,
    height: 0.871442,
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9907,
    y: 95.4678,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(-32.7217 32.9907 95.4678)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.1675,
    y: 83.6655,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(-32.7217 51.1675 83.6655)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.0137,
    cy: 91.8599,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(-33.1033 45.0137 91.8599)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9517,
    cy: 88.6751,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(-33.1303 42.9517 88.6751)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.9929,
    cy: 88.6409,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(-33.1033 42.9929 88.6409)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0613 87.8722L53.8638 87.2899L54.8131 88.6199L54.2592 89.5504L53.0613 87.8722Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6108 90.9009L51.4193 90.327L52.4342 91.7802L51.716 92.5113L50.6108 90.9009Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8136 93.3787L48.6262 92.8107L49.6473 94.2958L48.8327 94.916L47.8136 93.3787Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4727 95.4086L45.2943 94.8538L46.3844 96.4945L45.5031 97.0156L44.4727 95.4086Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.154 97.0732L41.9951 96.5483L43.0165 98.213L42.0853 98.5909L41.154 97.0732Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.514 98.1052L38.3799 97.6222L39.3351 99.3668L38.274 99.5213L37.514 98.1052Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.833 90.9546C38.9298 90.5625 39.414 89.752 40.5759 89.6475",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.833 90.8277C38.9298 90.4355 39.414 89.6251 40.5759 89.5205",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9053 87.0542C44.0021 86.6621 44.4862 85.8516 45.6482 85.7471",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9004 86.8677C43.9972 86.4756 44.4814 85.6651 45.6433 85.5605",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7713 90.5869C43.1783 90.6089 44.1251 90.3462 44.6564 89.1188",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5076 90.3505C42.91 90.3861 43.8336 90.1909 44.3093 89.1257",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.326,
    cy: 121.574,
    rx: 10.8036,
    ry: 10.9965,
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.279 121.381C161.279 127.561 156.27 132.57 150.09 132.57C143.91 132.57 138.9 127.561 138.9 121.381C138.9 115.201 143.91 110.191 150.09 110.191C156.27 110.191 161.279 115.201 161.279 121.381ZM142.093 121.381C142.093 125.798 145.673 129.378 150.09 129.378C154.507 129.378 158.087 125.798 158.087 121.381C158.087 116.964 154.507 113.384 150.09 113.384C145.673 113.384 142.093 116.964 142.093 121.381Z",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.115 120.601C146.456 120.214 147.343 119.674 148.162 120.601",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.706 124.42C151.194 124.999 149.863 125.81 148.635 124.42",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.254 120.601C152.596 120.214 153.482 119.674 154.301 120.601",
    stroke: "#F6D169",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.089 120.438C146.43 120.052 147.317 119.511 148.136 120.438",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.706 124.27C151.194 124.849 149.863 125.66 148.635 124.27",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 120.438C152.571 120.052 153.458 119.511 154.277 120.438",
    stroke: "#493500",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.457,
    y: 59.6135,
    width: 2.39647,
    height: 3.92149,
    transform: "rotate(43.4273 129.457 59.6135)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.268,
    y: 74.4365,
    width: 2.44534,
    height: 3.83755,
    transform: "rotate(43.4273 145.268 74.4365)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.838,
    cy: 70.4232,
    rx: 12.0974,
    ry: 4.67754,
    transform: "rotate(43.0457 135.838 70.4232)",
    fill: "#EEC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.437,
    cy: 67.6587,
    rx: 12.0929,
    ry: 4.25084,
    transform: "rotate(43.0187 138.437 67.6587)",
    fill: "#FFE9AA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.48,
    cy: 67.6905,
    rx: 9.5836,
    ry: 2.33706,
    transform: "rotate(43.0457 138.48 67.6905)",
    fill: "#F6D169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.637 77.2821L142.394 77.9218L141.33 79.1619L140.294 78.8469L141.637 77.2821Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11 75.6283L138.86 76.2758L137.692 77.6091L136.81 77.0868L138.11 75.6283Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.034 73.5055L135.78 74.1585L134.583 75.5054L133.786 74.863L135.034 73.5055Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.263 70.7475L132.999 71.4124L131.667 72.8636L130.95 72.1326L132.263 70.7475Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.852 67.9237L130.563 68.6147L129.192 70.0049L128.602 69.1912L129.852 67.9237Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.979 64.6368L128.655 65.3618L127.19 66.7069L126.786 65.7136L127.979 64.6368Z",
    fill: "#D39900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.238 64.2055C135.642 64.2056 136.544 64.4817 136.924 65.5848",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.361 64.175C135.765 64.1751 136.667 64.4512 137.047 65.5543",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.239 68.1965C140.643 68.1966 141.545 68.4726 141.925 69.5757",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.419 68.1472C140.823 68.1473 141.726 68.4233 142.105 69.5264",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.537 67.9411C136.613 68.3416 137.095 69.1979 138.414 69.4199",
    stroke: "#FFE9AA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.704 67.6286C136.766 68.0278 137.176 68.8778 138.324 69.0847",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_476_15227)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.0564,
    cy: 98.9439,
    r: 2.6111,
    fill: "#F9CA47"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_476_15227)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.93,
    cy: 120.486,
    r: 1.95833,
    fill: "#F9CA47"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_476_15227)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 175.763,
    cy: 174.013,
    r: 3.26388,
    fill: "#F9CA47"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_476_15227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4845 70.2222L64.7186 73.5574L68.0539 74.7916L64.7186 76.0258L63.4845 79.361L62.2503 76.0258L58.915 74.7916L62.2503 73.5574L63.4845 70.2222Z",
    fill: "#F9CA47"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_476_15227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.067 7.39715L134.362 10.4669L138.187 10.7227L135.117 13.018L134.861 16.8424L132.566 13.7726L128.741 13.5168L131.811 11.2216L132.067 7.39715Z",
    fill: "#F9CA47"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_476_15227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9391 175.48L29.8526 177.519L33.2972 176.635L31.258 179.548L32.1425 182.993L29.2289 180.954L25.7843 181.838L27.8235 178.924L26.9391 175.48Z",
    fill: "#F9CA47"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_476_15227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.814 159.81L206.354 162.704L210.856 161.901L207.962 165.441L208.765 169.942L205.225 167.048L200.724 167.851L203.618 164.311L202.814 159.81Z",
    fill: "#F9CA47"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_476_15227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1389 88.501L19.6072 95.1715L26.2777 97.6398L19.6072 100.108L17.1389 106.779L14.6705 100.108L8 97.6398L14.6705 95.1715L17.1389 88.501Z",
    fill: "#F9CA47"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_476_15227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.653 71.5273L197.887 74.8626L201.222 76.0968L197.887 77.3309L196.653 80.6662L195.419 77.3309L192.083 76.0968L195.419 74.8626L196.653 71.5273Z",
    fill: "#F9CA47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_476_15227",
    x: 41.0846,
    y: 179.943,
    width: 141.321,
    height: 23.8909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05,
    result: "effect1_foregroundBlur_476_15227"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_476_15227",
    x: 57.4453,
    y: 89.3328,
    width: 21.2222,
    height: 21.2222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_476_15227",
    x: 157.972,
    y: 111.528,
    width: 19.9165,
    height: 19.9167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_476_15227",
    x: 164.499,
    y: 163.749,
    width: 22.5278,
    height: 22.5278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_476_15227",
    x: 50.915,
    y: 63.2222,
    width: 25.1387,
    height: 25.1389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_476_15227",
    x: 120.741,
    y: 0.397217,
    width: 25.4453,
    height: 25.4451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_476_15227",
    x: 17.7842,
    y: 168.48,
    width: 23.5132,
    height: 23.5129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_476_15227",
    x: 192.724,
    y: 152.81,
    width: 26.1313,
    height: 26.1316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_476_15227",
    x: 0,
    y: 81.501,
    width: 34.2778,
    height: 34.2778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_476_15227",
    x: 184.083,
    y: 64.5273,
    width: 25.1387,
    height: 25.1389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.792157 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_476_15227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_476_15227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_15227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.583,
    height: 193.222,
    fill: "white",
    transform: "translate(30.1953 12.7783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsBag);
export default __webpack_public_path__ + "static/media/coins-bag.51d0d75cc540fdde027b5f2fcff5c30d.svg";
export { ForwardRef as ReactComponent };